import React from 'react';
import ReactDOM from 'react-dom/client';
import DesafioNatal from './DesafioNatal';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DesafioNatal />
  </React.StrictMode>
);

reportWebVitals();
